import { render, staticRenderFns } from "./RsaPazienteAttivitaObiettiviPage.vue?vue&type=template&id=3e44cab8"
import script from "./RsaPazienteAttivitaObiettiviPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteAttivitaObiettiviPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports